var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLentra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.06665L12.8704 8.01482C13.3513 8.20716 13.6667 8.67298 13.6667 9.19092V14.6667",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43311 6.43335H7.33311M5.43311 8.96669H7.33311",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65004 14.6667V12.1333C7.65004 11.7835 7.3665 11.5 7.01671 11.5H5.75003C5.40026 11.5 5.1167 11.7835 5.1167 12.1333V14.6667",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.6666H14.9334",
    stroke: "#2C8C53",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26675 14.6667L2.2666 2.63329C2.26684 2.21979 2.65682 1.91743 3.05735 2.0202L10.0171 3.80606C10.2972 3.87793 10.493 4.13037 10.493 4.41952L10.5001 14.6036",
    stroke: "#2C8C53",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLentra);
export default __webpack_public_path__ + "static/media/lentra.19c2eca8c3af52fafd877e74451c9746.svg";
export { ForwardRef as ReactComponent };